var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('router-view'),_c('div',{staticClass:"main__menu-button"},[_c('fab-button',{on:{"click":_vm.openMenu}},[_vm._v(" menu ")])],1),_c('mainMenu'),_c('loading',{attrs:{"show":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }